import { useQuery } from '@tanstack/react-query';

import { apiClient } from './api';
import {
  DataHealthResponseSchema,
  type CoachingDependency,
  type DataHealthResponse,
} from './types';
import { STALE_TIME_DAILY } from './query';

export function useDataHealth() {
  return useQuery<DataHealthResponse>({
    queryKey: ['data-health'],
    queryFn: () => apiClient.get<DataHealthResponse>('/api/data-health', { schema: DataHealthResponseSchema }),
    staleTime: STALE_TIME_DAILY,
    retry: 1,
  });
}

export function dataDependency(
  data: DataHealthResponse | undefined,
  key: CoachingDependency['key'],
): CoachingDependency | null {
  return data?.dependencies.find((d) => d.key === key) ?? null;
}
